import React, { useContext } from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import Badge from './elements/Badge';
import { ConfiguratorContext } from '../context/ConfiguratorProvider';

import * as locationStyles from './locations.module.scss';

const Location = ({
  title,
  excerpt,
  image,
  leImageVenue = false,
  locationUri,
  isSlide,
}) => {
  const [isDev] = useContext(ConfiguratorContext);
  return (
    <>
      {isDev && <pre>Location</pre>}
      {isSlide ? (
        <div className={locationStyles.locationCard}>
          {/* use a instead of Link to prevent navigate on touch scroll */}
          <a
            className={locationStyles.locationLink}
            href={locationUri}
            title={title}
          >
            {image ? (
              <GatsbyImage
                className={locationStyles.locationCardImage}
                image={image}
                alt=""
              />
            ) : (
              <div className={locationStyles.locationPlaceholder}></div>
            )}
            {leImageVenue && (
              <div className={locationStyles.locationBadge}>
                <Badge altClass={true} />
              </div>
            )}
            <div className={locationStyles.locationCardInfo}>
              <span className={locationStyles.locationCardText}>{title}</span>
              <div
                className={locationStyles.locationCardExcerpt}
                dangerouslySetInnerHTML={{ __html: excerpt }}
              ></div>
            </div>
            <span className={locationStyles.locationInfo}>More info</span>
          </a>
          {/* Link */}
        </div>
      ) : (
        <li className={locationStyles.locationCard}>
          <Link
            className={locationStyles.locationLink}
            to={locationUri}
            title={title}
          >
            {leImageVenue && (
              <div className={locationStyles.locationBadge}>
                <Badge altClass={true} />
              </div>
            )}
            {image ? (
              <GatsbyImage
                className={locationStyles.locationCardImage}
                image={image}
                alt=""
              />
            ) : (
              <div className={locationStyles.locationPlaceholder}></div>
            )}
            <div className={locationStyles.locationCardInfo}>
              <span className={locationStyles.locationCardText}>{title}</span>
              <div
                className={locationStyles.locationCardExcerpt}
                dangerouslySetInnerHTML={{ __html: excerpt }}
              ></div>
            </div>
            <span className={locationStyles.locationInfo}>More info</span>
          </Link>
        </li>
      )}
    </>
  );
};

export default Location;
